function JoinUs(){
    return(
        <div className="flex justify-center items-center flex-col pt-20 select-none px-5 text-[#042040]">

<div className="flex mx-auto justify-center flex-wrap md:flex-nowrap items-center gap-4 md:gap-10 max-w-[980px]">
  <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group px-5 py-8">
    <p className="font-bold text-left text-[#042040] text-md sm:text-lg lg:text-xl">Vous passez plus de temps à manipuler vos données financières sur Excel qu&apos;à les <span className="whitespace-nowrap">analyser ?</span></p>
  </div>

  <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group px-5 py-8">
    <p className="text-left font-bold text-[#042040] text-md sm:text-lg lg:text-xl">Vous avez du mal à analyser votre performance <span className="whitespace-nowrap">financière ?</span></p>
  </div>

  <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group px-5 py-8">
    <p className="text-left font-bold text-[#042040] text-md sm:text-lg lg:text-xl">Vos états financiers ne tiennent pas compte des spécificités de votre activités <span className="whitespace-nowrap">(vision par produit, client, etc.) ?</span></p>
  </div>

</div>

<div className="flex mx-auto justify-center flex-wrap md:flex-nowrap gap-4 md:gap-10 mt-4 md:mt-10 max-w-[980px]">
  <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group px-5 py-8">
    <p className="text-left font-bold text-[#042040] text-md sm:text-lg lg:text-xl">Vous n&apos;êtes pas à l&apos;aise pour construire vos prévisions <span className="whitespace-nowrap">financières ?</span></p>
  </div>

  <div className="bg-white col-start-1 justify-self-center md:justify-self-end fadeIn1 rounded-lg border border-4 border-[#042040] hover:border-[#FED90F] text-center shadow-[10px_10px_0px_#FED90F] hover:shadow-none ease-in duration-500 flex flex-col justify-center items-center overflow-hidden relative group px-5 py-8">
    <p className="text-left font-bold text-[#042040] text-md sm:text-lg lg:text-xl">Vous prenez des décisions d&apos;investissement sans données financières claires à <span className="whitespace-nowrap">l&apos;appui ?</span></p>
  </div>
</div>

<h4 className="font-bold text-[#042040] text-center mt-10 text-3xl md:text-5xl max-w-[980px] mx-auto leading-12">Si tout cela vous parle alors <br></br>rejoignez-nous !</h4>











            <p className="mt-4 text-xl md:text-2xl leading-8 text-[#042040] text-center">
            Bénéficiez d&apos;un accompagnement financier expert, taillé sur-mesure pour vos besoins.
            </p>

            <div className='flex justify-center items-center gap-5 sm:gap-10 mt-10 flex-col sm:flex-row'>
               
              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  <div className='absolute top-0 left-0 rounded-md bg-[#FED90F66] w-full h-full transform translate-x-2 translate-y-2 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500'></div>
                  
                  <div className="z-10 w-fit rounded-md px-3.5 py-2.5 border border-1 border-[#042040] relative transform translate-y-0 translate-x-0 group-hover:translate-y-1 group-hover:translate-x-1 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/decouverte"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Réserver votre démo
                      </a>
                  </div>
              </div>

              <div className='fadeIn relative w-fit h-fit group cursor-pointer'>
                  
                  <div className="z-10 w-fit py-1 border-b-2 border-[#FED90F33] hover:border-[#FED90F] relative transform translate-y-0 translate-x-0 ease-in-out duration-500">
                      <a
                          href="https://zcal.co/heelio/consultation"
                          target='_blank'
                          rel="noopener noreferrer"
                          className=" w-full h-full rounded-md text-sm font-bold tracking-wider text-[#042040] "
                      >
                          Prendre RDV avec un DAF*
                      </a>
                  </div>
              </div>

            </div>

            <p className='font-extralight text-xs md:text-sm mt-5 max-w-2/3 mb-20'>*Consultation gratuite : conseil sur votre environnement et vos problématiques financières</p>

        </div>

    )
}

export default JoinUs;